import { render, staticRenderFns } from "./ChessPlayer.vue?vue&type=template&id=eaf131d2&scoped=true&"
import script from "./ChessPlayer.vue?vue&type=script&lang=js&"
export * from "./ChessPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ChessPlayer.vue?vue&type=style&index=0&id=eaf131d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf131d2",
  null
  
)

export default component.exports